// text.jsx

import React from "react";
import TableData from "./FilmographyTableData"; // Adjust the path as necessary
// import "./Table.css";

const FilmographyTable = () => {
  const Awards = TableData.FilmographyTable;
  const { columns, data, title } = Awards;

  return (
    <div className="table-container">
      <div className="table-section table-style-2">
        {/* <h2>{title}</h2> */}
        <h1></h1>
        <table className="data-table">
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th key={index}>{column.name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                {columns.map((column, colIndex) => (
                  <td key={colIndex}>{column.selector(item)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FilmographyTable;
